/**
 * DSS Multicolumn — Swiper carousel
 * Mobile only: <= 767px
 * Fix: stuck pagination + multiple section conflict
 */
(function () {
  'use strict';

  var BREAKPOINT = 767;

  /*
   * instances: wrapper element → { swiper, pagEl }
   * WeakMap ensures no memory leaks when sections are removed from DOM
   */
  var instances = new WeakMap();

  /* ── DOM helpers ──────────────────────────────────────── */

  function getList(wrapper) {
    return wrapper.querySelector('.dss-multicolumn__list');
  }

  function getCards(wrapper) {
    return wrapper.querySelectorAll('.dss-multicolumn__card');
  }

  function getPagination(wrapper) {
    return wrapper.querySelector('.dss-multicolumn__pagination');
  }

  function prepareDOM(wrapper) {
    var list = getList(wrapper);
    if (list) list.classList.add('swiper-wrapper');
    getCards(wrapper).forEach(function (card) {
      card.classList.add('swiper-slide');
    });
  }

  function cleanDOM(wrapper) {
    var list = getList(wrapper);
    if (list) list.classList.remove('swiper-wrapper');
    getCards(wrapper).forEach(function (card) {
      card.classList.remove('swiper-slide');
    });
  }

  /* ── Manual pagination ────────────────────────────────── */

  function buildBullets(pagEl, count, activeIndex) {
    pagEl.innerHTML = '';
    for (var i = 0; i < count; i++) {
      var bullet = document.createElement('span');
      bullet.className = 'swiper-pagination-bullet' +
        (i === activeIndex ? ' swiper-pagination-bullet-active' : '');
      bullet.setAttribute('tabindex', '0');
      bullet.setAttribute('role', 'button');
      bullet.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      if (i === activeIndex) {
        bullet.setAttribute('aria-current', 'true');
      }
      pagEl.appendChild(bullet);
    }
  }

  /*
   * syncBullets — ALWAYS reads index from swiper.realIndex at call time.
   * Never uses a cached/closure index — this fixes the "stuck" bug.
   */
  function syncBullets(pagEl, swiper) {
    var activeIndex = swiper.realIndex;
    var bullets = pagEl.querySelectorAll('.swiper-pagination-bullet');
    bullets.forEach(function (b, i) {
      if (i === activeIndex) {
        b.classList.add('swiper-pagination-bullet-active');
        b.setAttribute('aria-current', 'true');
      } else {
        b.classList.remove('swiper-pagination-bullet-active');
        b.removeAttribute('aria-current');
      }
    });
  }

  /*
   * attachBulletClicks — pagEl is scoped to THIS section's wrapper only.
   * Each section gets its own closure — no cross-section conflicts.
   */
  function attachBulletClicks(pagEl, swiper) {
    pagEl.addEventListener('click', function (e) {
      var bullet = e.target.closest('.swiper-pagination-bullet');
      if (!bullet) return;
      var bullets = Array.prototype.slice.call(
        pagEl.querySelectorAll('.swiper-pagination-bullet')
      );
      var index = bullets.indexOf(bullet);
      if (index !== -1) swiper.slideTo(index);
    });

    pagEl.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var bullet = e.target.closest('.swiper-pagination-bullet');
      if (!bullet) return;
      var bullets = Array.prototype.slice.call(
        pagEl.querySelectorAll('.swiper-pagination-bullet')
      );
      var index = bullets.indexOf(bullet);
      if (index !== -1) swiper.slideTo(index);
    });
  }

  /* ── Swiper options ───────────────────────────────────── */

  function buildOptions(mobileCols) {
    return {
      slidesPerView            : mobileCols,
      spaceBetween             : 16,
      grabCursor               : true,
      watchOverflow            : true,
      simulateTouch            : true,
      touchStartPreventDefault : false,
      threshold                : 5,
      longSwipesRatio          : 0.15,
      longSwipesMs             : 100,
      pagination               : false,
      breakpoints              : {
        481: { slidesPerView: mobileCols, spaceBetween: 20 }
      }
    };
  }

  /* ── init / destroy ───────────────────────────────────── */

  function initSwiper(wrapper) {
    prepareDOM(wrapper);

    var mobileCols = parseInt(wrapper.getAttribute('data-cols-mobile'), 10) || 1;
    var swiper     = new window.Swiper(wrapper, buildOptions(mobileCols));
    var pagEl      = getPagination(wrapper);

    /*
     * Store BOTH swiper + pagEl together.
     * pagEl is wrapper-scoped — each section has its own reference.
     */
    instances.set(wrapper, { swiper: swiper, pagEl: pagEl });

    if (!pagEl) return;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        swiper.update();

        buildBullets(pagEl, swiper.slides.length, swiper.realIndex);
        attachBulletClicks(pagEl, swiper);

        /*
         * slideChange — pagEl passed directly, NOT via outer closure.
         * This ensures each section's handler only touches its own bullets.
         */
        swiper.on('slideChange', function () {
          syncBullets(pagEl, swiper);
        });

        /*
         * transitionEnd — fires AFTER animation completes.
         * Fixes "stuck" bug: realIndex is guaranteed settled here.
         */
        swiper.on('transitionEnd', function () {
          syncBullets(pagEl, swiper);
        });
      });
    });
  }

  function destroySwiper(wrapper) {
    var entry = instances.get(wrapper);
    if (entry) {
      entry.swiper.destroy(true, true);
      if (entry.pagEl) entry.pagEl.innerHTML = '';
      instances.delete(wrapper);
    }
    cleanDOM(wrapper);
  }

  /* ── manage ───────────────────────────────────────────── */

  function manage(wrapper) {
    if (typeof window.Swiper === 'undefined') return;

    var active    = instances.has(wrapper);
    var shouldRun = window.innerWidth <= BREAKPOINT;

    if (shouldRun && !active)      { initSwiper(wrapper);    }
    else if (!shouldRun && active) { destroySwiper(wrapper); }
  }

  function initAll() {
    document
      .querySelectorAll(
        '.dss-multicolumn--has-carousel .dss-multicolumn__wrapper.swiper'
      )
      .forEach(manage);
  }

  /* ── boot ─────────────────────────────────────────────── */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initAll, 150);
  });

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load',   initAll);
    document.addEventListener('shopify:section:unload', initAll);
    document.addEventListener('shopify:block:select',   initAll);
  }

})();